interface SectionHeadingProps {
  eyebrow: string;
  title: string;
  desc?: string;
  align?: "left" | "center";
  accent?: "primary" | "accent" | "secondary";
}

export default function SectionHeading({
  eyebrow,
  title,
  desc,
  align = "left",
  accent = "primary",
}: SectionHeadingProps) {
  const accentText =
    accent === "accent" ? "text-accent-600" : accent === "secondary" ? "text-secondary-700" : "text-primary-600";

  return (
    <div className={align === "center" ? "mx-auto max-w-2xl text-center" : "max-w-2xl"}>
      <span className={`font-label text-xs font-bold uppercase tracking-[0.2em] ${accentText}`}>{eyebrow}</span>
      <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">{title}</h2>
      {desc && <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">{desc}</p>}
    </div>
  );
}